<script setup>
const props = defineProps({
    minDate: {
        type: [Date, String, Number],
        default: null,
    },
    masks: {
        type: Object,
        default: () => ({
            input: 'YYYY-MM-DD',
            data: 'YYYY-MM-DD',
        }),
    },
    placeholder: {
        type: String,
        default: 'Select date',
    },
    disabledDates: {
        type: Array,
        default: () => [],
    },
});
const emit = defineEmits(['dayclick']);
const model = defineModel();

function selectDate(value) {
    emit('dayclick', value);
}
</script>

<template>
    <div>
        <VDatePicker v-model="model" :masks="masks" :min-date="minDate" :disabled-dates="disabledDates"
            @dayclick="selectDate">
            <template #default="{ inputValue, inputEvents }">
                <div class="relative">
                    <input class="bg-white h-14 rounded-md border-2 border-orange-400 px-12 w-full" :value="inputValue"
                        v-on="inputEvents" :placeholder="placeholder" />
                    <svg class="absolute top-4 left-4" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960"
                        width="24px" fill="#FF8818">
                        <path
                            d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z" />
                    </svg>
                </div>
            </template>
        </VDatePicker>
    </div>
</template>

<style scoped></style>